import { serverAxios } from '@/shared/api';
import { ArticleResponseItem, AuthorResponseItem } from '@/shared/types';

export interface AuthorTrend {
  rank: number;
  author: AuthorResponseItem;
  news: ArticleResponseItem[];
}

type AuthorTrendApiResponse = {
  author_trend: AuthorTrend[];
};

export const authorTrendApi = async () => {
  return await serverAxios.get<AuthorTrendApiResponse>(
    '/yozmit/authors/trend/'
  );
};
